
import { useNavigate } from 'react-router-dom';
import Navigation from '@/components/landing/Navigation';
import Hero from '@/components/landing/Hero';
import TestimonialSection from '@/components/landing/TestimonialSection';

import Features from '@/components/landing/Features';
import Footer from '@/components/landing/Footer';
import PricingSection from '@/components/landing/pricing/PricingSection';
import ReferralSection from '@/components/landing/ReferralSection';
// import { useIsMobile } from '@/hooks/use-mobile';
import { isIOSNativeApp } from '@/utils/platformUtils';

interface LandingProps {
  isReferral?: boolean;
  referralCode?: string;
}

const Landing = ({ isReferral, referralCode }: LandingProps = {}) => {
  const navigate = useNavigate();
  const isNativeIOS = isIOSNativeApp();

  // Handle login/signup clicks from the landing page
  const handleLogin = () => {
    navigate('/auth/login');
  };

  const handleSignup = () => {
    if (referralCode) {
      navigate(`/auth/signup?ref=${referralCode}`);
    } else {
      navigate('/auth/signup');
    }
  };

  // Get container classes based on platform
  const getContainerClasses = () => {
    if (isNativeIOS) {
      return 'landing-page bg-white';
    }
    return 'landing-page bg-white min-h-screen';
  };

  return (
    <div className={getContainerClasses()}>
      <Navigation onLogin={handleLogin} onSignup={handleSignup} />
      <Hero onGetStarted={handleSignup} />
      
      {isReferral && (
        <ReferralSection isReferral={true} referralCode={referralCode} />
      )}
      
      <TestimonialSection />
      <Features />
      <div id="pricing-section" className="pt-12 pb-20">
        <PricingSection />
      </div>
      <Footer />
    </div>
  );
};

export default Landing;
